export default class RatingPoint {
    public value: number;

    constructor(value: number) {
      this.value = value;
    }
}
